<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GcsaU7/media/FC-9781398477490.jpg?1692049852632" alt="This image is the cover for the book The Conversation Club"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Conversation Club
      </h1>
      <p class="bookDescription body article font2">
        <p>Centuries ago, the Egyptian Pharaoh Akhenaten appointed a council of 22 custodians to foster the flourishing of the human spirit through the pursuit of knowledge, the advance of the arts, and covert philanthropy. Today, the London Chapter of that council is known as The Conversation Club. It is helmed by Esau Monk, who guards its activities and astounding wealth with ironclad secrecy, but its very existence and purpose are threatened from within. 60 years ago, in Nazi Germany, Wolfgang Ackerman smuggled 22 boys and a hoard of stolen gold out of the country at the outbreak of the war. Their destination: London, and The Conversation Club. Unknown to anyone but him, he has secretly substituted his own son for one of the boys and is haunted by guilt. Now, in London, someone is carrying out brutal murders. The security services are convinced Islamic terrorists are behind the atrocities. Former FBI profiler, Dr. Ben Whisker, disagrees. He discerns something far more deadly than meets the eye. His recent fall from professional grace, however, means he is not being taken seriously. Realising that the impenetrable Conversation Club is the focus of the violence, he teams up with the Grand Master of the Club, Esau Monk, to figure out what the connection is.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Declan J. S. Moloney
      </h2>
      
      <p class="authorDescription body article">Possibly following generations in seafaring, but seasickness interrupted, rock stardom called, but hung up. University in Trinity College Dublin did call and the love of story overtook, followed by adventures in the US and UK. A few books later, and a curious stumble into interior design, Declan J. S. Moloney is back in his happy place of imagination and a story to share.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?66da0fc0